import Button from "../../../../../lib/html5-software-library/src/ranj/components/buttons/Button";

export default class CompositeButton extends Button {
    constructor() {
        super(new createjs.MovieClip());

        this._buttons = [];
    }

    destroy() {
        super.destroy();

        for (let i = 0; i < this._buttons.length; i++) {
            const button = this._buttons[i];
            this._removeListenersFromButton(button);
            button.destroy();
        }
    }

    
    setVisible(value) {
        super.setVisible(value);

        for (let i = 0; i < this._buttons.length; i++) {
            const button = this._buttons[i];
            button.setVisible(value);
        }
    }

    setLabel(value) {
        super.setLabel(value);

        for (let i = 0; i < this._buttons.length; i++) {
            const button = this._buttons[i];
            button.setLabel(value);
        }
    }

    setCenteredLabel(value) {
        super.setCenteredLabel(value);

        for (let i = 0; i < this._buttons.length; i++) {
            const button = this._buttons[i];
            button.setCenteredLabel(value);
        }
    }

    _setState(value) {
        super._setState(value);

        const buttons = this._buttons || []; // Default to an empty array as `this._buttons` might not be declared yet as `_setState` is called in the super constructor.
        for (let i = 0; i < buttons.length; i++) {
            const button = buttons[i];
            button._setState(value);
        }
    }

    addSkinAsButton(skin) {
        this.addButton(new Button(skin));
    }

    addButton(button) {
        this._addListenersToButton(button);
        this._buttons.push(button);
    }

    _addListenersToButton(button) {
        button.addEventListener("click", this._handleClickBound);
        button.addEventListener("dblclick", this._handleDoubleClickBound);
        button.addEventListener("mousedown", this._handleMouseDownBound);
        button.addEventListener("pressup", this._handleMouseUpBound);
        button.addEventListener("pressmove", this._handleMouseMoveBound);
        button.addEventListener("mouseout", this._handleMouseOutBound);
        button.addEventListener("mouseover", this._handleMouseOverBound);
        button.addEventListener("rollover", this._handleRollOverBound);
        button.addEventListener("rollout", this._handleRollOutBound);
        button.addEventListener("added", this._handleAddedToStageBound);
    }

    _removeListenersFromButton(button) {
        button.removeEventListener("click", this._handleClickBound);
        button.removeEventListener("dblclick", this._handleDoubleClickBound);
        button.removeEventListener("mousedown", this._handleMouseDownBound);
        button.removeEventListener("pressup", this._handleMouseUpBound);
        button.removeEventListener("pressmove", this._handleMouseMoveBound);
        button.removeEventListener("mouseout", this._handleMouseOutBound);
        button.removeEventListener("mouseover", this._handleMouseOverBound);
        button.removeEventListener("rollover", this._handleRollOverBound);
        button.removeEventListener("rollout", this._handleRollOutBound);
        button.removeEventListener("added", this._handleAddedToStageBound);
    }
}